import React from 'react'
import { batch, useSignal } from '@preact/signals-react'

import { AppAsyncOfficesAutocomplete } from '@components'
import { errors, offices, officesOptions } from '@signals'


export default function AppCommonFiltersOfficesAutocomplete({ onOptions, ...props }) {

	const justRendered = useSignal(true)
	return <AppAsyncOfficesAutocomplete
		value={offices.value || null}
		error={errors.value?.offices}
		label="Pickup Offices"
		onChange={e => batch(() => {
			offices.value = e.target.value
		})}
		onFinishAjax={options => {
			if (!props.multiple) {
				if (props?.autoSelect && justRendered.value) {
					offices.value = options[0]?.value || offices.value || null
				} else {
					offices.value = options?.filter(d => d?.selected)[0]?.value || offices.value || null
				}
			}
			officesOptions.value = officesOptions.value.length ? officesOptions.value.map(a => {
				return {
					...a,
					...options.some(b => b.value === a.value) && {
						officeNoResults: options.officeNoResults,
					},
				}
			}) : options
			justRendered.value = false
			// after its own logic: a page that wants the options (CU-869fmk5ge B1)
			onOptions?.(options)
		}}
		filters={{
			id_office_pickup: offices.value,
			...props?.filters,
		}}
        inputProps={{
            onKeyDown: (e) => {
                if (!props.multiple && !!offices.value){
                    const allowedKeys = ['Tab','Shift', 'Control', 'Alt', 'Meta'];
                    if (allowedKeys.includes(e.key)) {
                        return;
                    }
                    e.preventDefault();
                    batch(() => {
                        offices.value = null;
                    });
                }
            }
        }}
		{...props}
	/>
}